import {NgModule} from '@angular/core';
import {PerformanceComponent} from './performance.component';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {PerfOverallModule} from "../perf-overall/perf-overall.module";
import {PerfTrendModule} from "../perf-trend/perf-trend.module";
import {PerfMetricsModule} from "../perf-metrics/perf-metrics.module";
import {PerfHelpModule} from "../perf-help/perf-help.module";
import { PulsePerfTrendModule } from '../pulse-perf-trend/pulse-perf-trend.module';
import { InsightsDepartmentPerformanceModule } from '../insights-department-performance/insights-department-performance/insights-department-performance.module';
import { PulsePerformanceTabsModule } from '../pulse-performance-tabs/pulse-performance-tabs.module';
import { LoaderModule } from '../loader/loader.module';

@NgModule({ declarations: [PerformanceComponent],
    exports: [PerformanceComponent], imports: [BrowserModule,
        FormsModule,
        PerfOverallModule,
        PulsePerfTrendModule,
        PerfTrendModule,
        PerfMetricsModule,
        PerfHelpModule,
        InsightsDepartmentPerformanceModule,
        PulsePerformanceTabsModule,
        LoaderModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PerformanceModule { }
